export const CART_JOURNEY_ID = 'online-shop/cart';
export const DELETE_BUNDLE_CONTENT_KEY = 'deleteBundle.text';
export const DELETE_ITEM_CONTENT_KEY = 'deleteItem.text';
export const DELETE_FAILED_CONTENT_KEY = 'deleteFailed.text';
export const UNDO_FAILED_CONTENT_KEY = 'undoFailed.text';
export const SAVE_CART_INFO_LAYER_TITLE_CONTENT_KEY = 'saveCartInfoLayer.title';
export const SAVE_CART_INFO_LAYER_DESCRIPTION_CONTENT_KEY =
  'saveCartInfoLayer.description';
export const SAVE_CART_INFO_LAYER_SUCCESS_TITTLE_CONTENT_KEY =
  'saveCartInfoLayer.successTitle';
export const SAVE_CART_INFO_LAYER_SUCCESS_MESSAGE_CONTENT_KEY =
  'saveCartInfoLayer.successMessage';
export const SAVE_CART_INFO_LAYER_ERROR_MESSAGE_CONTENT_KEY =
  'saveCartInfoLayer.errorMessage';
export const SAVE_CART_INFO_LAYER_SUBSCRIBED_MESSAGE_CONTENT_KEY =
  'saveCartInfoLayer.subscribedMessage';
